import { render, staticRenderFns } from "./ecvWaveFooter.vue?vue&type=template&id=7220dcc7"
import script from "./ecvWaveFooter.vue?vue&type=script&lang=js"
export * from "./ecvWaveFooter.vue?vue&type=script&lang=js"
import style0 from "./ecvWaveFooter.vue?vue&type=style&index=0&id=7220dcc7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports